import { Component, OnInit, HostListener } from '@angular/core';
import { ProductService } from "../../_services/product.service";
import { isNgTemplate } from '@angular/compiler';
import { CommonService } from "../../_services/common.service";
import { MatDialog } from "@angular/material";
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import { OwnGarmentComponent } from '../own-garment/own-garment.component';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CodegenComponentFactoryResolver } from '@angular/core/src/linker/component_factory_resolver';
import { Router } from '@angular/router';
import { SettingService } from '../../_services/setting.service';
import { AddQuickItemComponent } from '../../mnt-products/add-quick-item/add-quick-item.component';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {
  public productLists: Array<any> = [];
  public colorGroupOptions: Array<any> = [];
  public productOptions: any = {};
  public productFilters: any = {};
  public loading = false;
  public page = 1;
  public limit = 12;
  public is_best_seller_enable = true;
  public is_less_order_limit_enable = false;
  public sortColumnName: string = "best_seller";
  public sortDirection: string = "desc";
  public productCurrentFilters = [];
  public priceFilterBy = "";
  public isPriceFilterEnable = true;
  public catalogueNameFilterBy = "";
  public catalogueValFilterBy = "";
  public isCalatlogueFilterEnable = true;
  public isCategoryFilterEnable = true;
  public isBrandFilterEnable = true;
  public isColorFilterEnable = true;
  public selectedMultiFilterOpt = [];
  public colorGroupMulti = [];
  public filterText: string;
  public localStorage = [];
  public productSorting = { orderBy: "best_seller", direction: "desc" };
  //public pfMainFilters:any={};
  public grandTotalPrice = 0;
  public totalProjectQuantity: any = [];
  public activeProjectIndex = "";
  public projects: any = {};
  public isShowSlide = false;
  public productMatrix: any = [];
  public isPublicQuoteCreation = false;
  public minHeight: string = '';
  public defaultWindowWidth = 1024;
  public limitDependsOnWindowWidth = 12;
  public selectedQuickItem: any = [];
  public quickItems: any = [];
  constructor(private ProductService: ProductService,
    private CommonService: CommonService,
    private dialog: MatDialog,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private settingService: SettingService
  ) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isAccessInvoiceType();
  }

  ngOnInit() {
    this.onResize(null);
    let pfMainFilters = JSON.parse(localStorage.getItem('pfMainFilters'));
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.totalProjectQuantity = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalProjectQuantity()));
    this.grandTotalPrice = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalPrice()));
    if (localStorage.pfMainFilters) {
      this.selectedMultiFilterOpt = pfMainFilters.selectedMultiFilterOpt;
      this.productCurrentFilters = pfMainFilters.product_current_filters;
      this.filterText = pfMainFilters.search_text;
      this.productSorting = pfMainFilters.productSorting;
      this.isCategoryFilterEnable = pfMainFilters.isCategoryFilterEnable;
      this.isBrandFilterEnable = pfMainFilters.isBrandFilterEnable;
      this.isColorFilterEnable = pfMainFilters.isColorFilterEnable;
      localStorage.removeItem('pfMainFilters');
    }
    this.CommonProjectDataService.storeCurrentIndexForStep(1);
    this.getProductFilter('all');
    this.getProducts();
    this.productMatrix = this.CommonProjectDataService.getProductMatrix();
    this.getQuickItemAttributes(['items']);

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.minHeight = window.innerHeight + 'px';
    const limitWidth = Math.round(window.innerWidth / this.defaultWindowWidth);
    this.limit = Math.max(this.limit, Math.round(limitWidth * this.limitDependsOnWindowWidth));
  }

  onActiveSlider() {
    this.isShowSlide = this.isShowSlide == false ? true : false;
  }

  getProducts = function () {
    this.loading = true;
    let is_order = true;


    this.productOptions = {
      limit: this.limit,
      page: this.page,
      is_order: is_order,
      best_seller: this.is_best_seller_enable,
      less_order_limit: this.is_less_order_limit_enable
    };
    if (this.filterText) {
      this.productOptions.search = this.filterText;
    }
    if (this.catalogueValFilterBy) {
      this.productOptions.provider = this.catalogueValFilterBy;
    }

    //if (this.sortColumnName=='best_seller') {
    this.productOptions.orderBy = this.sortColumnName;
    this.productOptions.direction = this.sortDirection;
    //}
    if (this.productCurrentFilters.length > 0) {
      this.productCurrentFilters.forEach(fvalue => {
        if (fvalue.tag == "style_id" || fvalue.tag == "fit_id") {
          if (
            this.productOptions[fvalue.tag] &&
            this.productOptions[fvalue.tag].length > 0
          ) {
            this.productOptions[fvalue.tag].push(fvalue.value);
          } else {
            this.productOptions[fvalue.tag] = [fvalue.value];
          }
        } else {
          this.productOptions[fvalue.tag] = fvalue.value;
        }
      });
    }

    this.ProductService.getProducts(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          //this.productLists =response.data.records.length > 0 ? response.data.records : [];
          //this.productLists.concat([response.data.records]);
          response.data.records.filter(x => x.hide_product != 1).forEach(item => {
            // Check if product_id and provider already exist in this.productLists
            const exists = this.productLists.some(itemData => itemData.product_id === item.product_id && itemData.provider === item.provider);
            if (!exists) {
              this.productLists.push(
                {
                  'style_image': item.style_image,
                  'best_seller': item.best_seller,
                  'brand': item.brand,
                  'colors': item.colors,
                  'image': item.image,
                  'less_order_limit': item.less_order_limit,
                  'name': item.name,
                  'price': item.price,
                  'provider': item.provider,
                  'product_id': item.product_id,
                  'title': item.title
                }
              );
            }
          });

          //this.total = response.data.total;
          //this.current_page = response.data.current_page;
          this.limit = response.data.limit;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
    this.setProductFilterLocalStorage();
  };

  onScroll() {
    this.page = this.page + 1;
    this.getProducts();
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  getProductFilter = function (catalogue) {
    this.loading = true;
    if (catalogue == 'all') {
      this.productOptions = {
        id: localStorage.getItem("userID")
      };
    } else {
      this.productOptions = {
        id: localStorage.getItem("userID"),
        provider: catalogue
      };
    }
    this.CommonService.apiService(
      "POST",
      "products/filters",
      this.productOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.productFilters = response.data;
          this.CommonProjectDataService.storeProductMatrix(response.data.product_matrix);
          this.CommonProjectDataService.storeMinOrderQty(response.data.min_order_qty);
          this.CommonProjectDataService.storeTurnOffPriceView(response.data.turn_off_price_per_peice && response.data.turn_off_price_per_peice == '1' ? true : false);
          this.CommonProjectDataService.storeTurnOffImpressionCost(response.data.turn_off_impression_cost && response.data.turn_off_impression_cost == '1' ? true : false);
          this.CommonProjectDataService.storeTurnOffSSInventory(response.data.turn_off_ss_inventory && response.data.turn_off_ss_inventory == '1' ? true : false);
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  setProductFilter(filterDataVal, filterType, filterDataName) {
    if (filterType == "category_id") {
      this.isCategoryFilterEnable = false;
    }
    if (filterType == "brand_id") {
      this.isBrandFilterEnable = false;
    }
    var selItem = null;
    if (filterType == "style_id" || filterType == "fit_id") {
      if (this.selectedMultiFilterOpt[filterType] && this.selectedMultiFilterOpt[filterType].length > 0) {
        //prevent duplicate request
        selItem = this.selectedMultiFilterOpt[filterType].filter(function (
          item
        ) {
          return item == filterDataVal ? true : false;
        })[0];
        if (selItem == null) {
          this.selectedMultiFilterOpt[filterType].push(filterDataVal);
        }
      } else {
        this.selectedMultiFilterOpt[filterType] = [filterDataVal];
      }
    }
    if (filterType == "color_family_id") {
      //colorGroupOptions
      let selColorFamily = this.productFilters.colors.filter(function (
        item
      ) {
        return item.color_family_id == filterDataVal;
      })[0];

      this.colorGroupOptions = selColorFamily.groups;

    }
    if (filterType == "color_group_id") {
      this.isColorFilterEnable = false;
    }

    if (selItem == null) {
      this.manageFilters(filterType, {
        name: filterDataName,
        tag: filterType,
        value: filterDataVal
      });
      this.resetPaging();
      this.getProducts();
    }
  }

  manageFilters(filterType, filterObj) {
    this.resetPaging();
    if (filterType == "color_group_id") {
      //prevent duplicate request
      this.productCurrentFilters = this.productCurrentFilters.filter(
        function (item) {
          return item.tag != "color_group_id";
        }
      );
    }
    if (this.productCurrentFilters.length > 0) {
      this.productCurrentFilters.push(filterObj);
    } else {
      this.productCurrentFilters = [filterObj];
    }
  };

  manageSorting(orderBy, direction) {
    this.resetPaging();
    this.sortColumnName = orderBy;
    if (orderBy == "best_seller") {
      this.is_best_seller_enable = this.is_best_seller_enable == true ? false : true;
      this.sortDirection = this.is_best_seller_enable == false ? 'asc' : 'desc';
      if (this.productCurrentFilters.length > 0) {
        this.productCurrentFilters.push({
          tag: "best_seller",
          value: this.is_best_seller_enable
        });
      } else {
        this.productCurrentFilters = [
          {
            tag: "best_seller",
            value: this.is_best_seller_enable
          }
        ];
      }
    }
    if (orderBy == "less_order_limit") {
      this.is_less_order_limit_enable = this.is_less_order_limit_enable == true ? false : true;
      if (this.is_less_order_limit_enable == false) {
        this.sortColumnName = 'best_seller';
        this.sortDirection = 'desc';
      }
      else {
        this.sortColumnName = 'best_seller';
        this.sortDirection = 'desc';
      }

    }
    if (orderBy == "price") {
      this.priceFilterBy = direction === 'asc' ? "Low to High" : "High to Low";
      this.isPriceFilterEnable = false;
      this.sortDirection = direction;
      this.sortColumnName = orderBy;
    }

    this.getProducts();
  }

  removePriceFilter() {
    this.priceFilterBy = "";
    this.isPriceFilterEnable = true;
    this.sortColumnName = 'best_seller';
    this.sortDirection = 'desc';
    this.resetPaging();
    this.getProducts();
  }

  manageCatalogue(catalogueValue, catalogueName) {
    this.resetPaging();
    this.isCalatlogueFilterEnable = false;
    this.catalogueNameFilterBy = catalogueName;
    this.catalogueValFilterBy = catalogueValue;
    this.getProductFilter(catalogueValue);
    this.getProducts();
  }

  removeCatalogueFilter() {
    this.catalogueNameFilterBy = "";
    this.catalogueValFilterBy = "";
    this.isCalatlogueFilterEnable = true;
    this.resetPaging();
    this.getProductFilter('all');
    this.getProducts();
  }

  isBestPrice(bestprice) {
    if (bestprice != 0) {
      return { 'background': 'url(' + this.productFilters.site_best_seller_image + ') center no-repeat' };
    }
    else {
      return { 'background': 'none' };
    }
  }

  resetPaging() {
    this.productLists = [];
    this.page = 1;
  }

  removeFilter(kindex, filterType, filterVal) {
    this.resetPaging();
    if (filterType == "category_id") {
      this.isCategoryFilterEnable = true;
    }
    if (filterType == "brand_id") {
      this.isBrandFilterEnable = true;
    }
    if (filterType == "color_family_id") {
      this.isColorFilterEnable = true;
      this.colorGroupOptions = [];
      // this.productCurrentFilters.some(
      //   function(item:any,kindex:number)
      //   {
      //   if(this.product_current_filters[kindex].tag === 'color_group_id'){
      //     // found it!
      //     this.productCurrentFilters.splice(kindex, 1);
      //   }
      // });
    }
    if (filterType == "color_group_id") {
      this.isColorFilterEnable = true;
    }
    if (filterType == "style_id" || filterType == "fit_id") {
      var tmp_filter = this.selectedMultiFilterOpt[filterType].filter(
        function (item) {
          return item != filterVal;
        }
      );
      this.selectedMultiFilterOpt[filterType] = tmp_filter;
    }

    this.productCurrentFilters.splice(kindex, 1);
    this.getProducts();
  };

  clearSearchText(): void {
    this.filterText = "";
    this.resetPaging();
    this.getProducts();
  };

  searchProduct(event) {
    if (this.filterText && this.filterText != '' && this.filterText.length >= 3) {
      this.resetPaging();
      this.getProducts();
    }
    if (!this.filterText) {
      this.resetPaging();
      this.getProducts();
    }
  };

  setProductFilterLocalStorage() {
    let plbrandsValue = JSON.parse(localStorage.getItem('plbrandsValue'));
    if (plbrandsValue && plbrandsValue.brand_id) {
      this.productCurrentFilters = [
        {
          name: localStorage.plbrandsValue.brandName,
          tag: "brand_id",
          value: localStorage.plbrandsValue.brand_id
        }
      ];
      // clear value form local storage
      localStorage.setItem('plbrandsValue', JSON.stringify({}));
    }
    let pfMainFilters = JSON.parse(localStorage.getItem('pfMainFilters'));
    if (!pfMainFilters) {
      pfMainFilters = { selectedMultiFilterOpt: this.selectedMultiFilterOpt };
    }

    pfMainFilters.selectedMultiFilterOpt = this.selectedMultiFilterOpt;
    pfMainFilters.product_current_filters = this.productCurrentFilters;
    pfMainFilters.search_text = this.filterText;
    pfMainFilters.productSorting = this.productSorting;
    pfMainFilters.isCategoryFilterEnable = this.isCategoryFilterEnable;
    pfMainFilters.isBrandFilterEnable = this.isBrandFilterEnable;
    pfMainFilters.isColorFilterEnable = this.isColorFilterEnable;
    localStorage.setItem('pfMainFilters', JSON.stringify(pfMainFilters));

  }

  showProductDetail(productId, price, matrixId = null): void {
    const dialogRef = this.dialog.open(ProductDetailComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        productId: productId,
        price: price,
        matrixId: matrixId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedQuickItem = [];
    });

  }

  showOwnGarment(): void {

    const dialogRef = this.dialog.open(OwnGarmentComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        productFilters: this.productFilters
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });

  }

  showImage(image: any){
    if(image){
      image = image.replace('//cdnl.', '//cdnm.');
    }
    return image;
  }

  isAccessInvoiceType() {
    const hasOrderType = this.CommonProjectDataService.getOrderType();
    const isInvoiceEditable = this.CommonProjectDataService.getIsInvoiceEditable();
    const isRedirectUrl = this.settingService.isAccessInvoiceType(hasOrderType, this.isPublicQuoteCreation, isInvoiceEditable);
    if (isRedirectUrl) {
      return this.router.navigate([isRedirectUrl]);
    }
  }

  createQuickItem(): void {
    const dialogRef = this.dialog.open(AddQuickItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.productId) {
        this.showProductDetail(result.productId, 0, result.matrixId);
      }
    });
  }

  getQuickItemAttributes = function (attributes) {
    this.options = {
      id: localStorage.getItem("userID"),
      attributes: attributes
    }
    this.CommonService.apiService(
      "POST",
      "quickItem/attributes",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.quickItems = response.data.items ? response.data.items : this.items;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  onQuickItemChange(event: any) {
    if (this.selectedQuickItem) {
      this.showProductDetail(this.selectedQuickItem.product_id, 0, this.selectedQuickItem.matrix_option_id);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/product-list/product-list.component.ts